import { AppealIdType } from "../model/enum";
import { IAppealInfoRequest, IAppealSubmissionRequest, IAppealSubmissionResponse, IAppealInfoResponse, IAccountAppealSubmissionRequest, IAccountAppealSubmissionResponse, IAccountAppealInfoResponse, IAccountAppealInfoRequest } from "../model/interface";
import env from "./env";
import { getCaptchaAccessToken, withSourceHeader } from "uicomponents";
import httpClient from "./httpClient";
import { APPEALS_SOURCE } from "../constants/constants";

const appealsUrl = env.REACT_APP_API_URL + "/api/appeals";

function getHeaders() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-store',
    };
}

function getAuthHeaders(source?: string): { [key: string]: string } | null {
    const authToken = getCaptchaAccessToken();
    if (!authToken) {
        return null;
    }
    let headers: { [key: string]: string } = getHeaders();
    headers['Authorization'] = `Bearer ${authToken}`;
    if (source) {
        headers = withSourceHeader(headers, source);
    }
    if (process.env.NODE_ENV === "development") {
        headers['X-Forwarded-For'] = 'localhost';
    }
    return headers;
}

export async function getInitialAppealerInfo(request: IAppealInfoRequest) {
    let initialResponse: IAppealInfoResponse = {
        appealNumber: "",
        appealIdType: AppealIdType.Unknown,
        appealerName: "",
        contactEmail: "",
        appealDate: "",
        policyViolated: "",
        product: "",
        reportId: "",
        appealerJustification: "",
        eligibilityPeriod: "",
        appealPeriodValid: false,
        hasInitialError: false
    };

    const headers = getAuthHeaders();
    if (!headers) {
        initialResponse.hasInitialError = true;
        return initialResponse;
    }

    await httpClient.get(appealsUrl, {
        params: {
            formId: request.formId,
            locale: request.locale
        },
        headers: headers
    })
        .then(function (res) {
            if (res.status === 200) {
                initialResponse = { ...res.data };
            }

            else {
                initialResponse.hasInitialError = true;
            }
        })
        .catch(function (error) {
            if (error.response?.status === 401) {
                throw error;
            }
            initialResponse.hasInitialError = true;
        })

    return initialResponse;
}

export async function getAccountAppealInfo(request: IAccountAppealInfoRequest) {
    let response: IAccountAppealInfoResponse = {
        appealNumber: "",
        couldFindSuspendedUserId: false,
        shouldAskForProduct: false,
        hasError: false
    };

    const headers = getAuthHeaders(APPEALS_SOURCE.ACCOUNT);
    if (!headers) {
        response.hasError = true;
        return response;
    }

    await httpClient.post(appealsUrl + "/account-info", {
        userId: request.userId,
    }, {
        headers: headers
    })
        .then(function (res) {
            if (res.status === 200) {
                response = { ...res.data };
            }

            if (res.status === 500) {
                response.hasError = true;
            }
        })
        .catch(function (error) {
            if (error.response?.status === 401) {
                throw error;
            }

            response.hasError = true;
        })

    return response;
};

export async function postAppeal(request: IAppealSubmissionRequest) {
    let appealResponse: IAppealSubmissionResponse = {
        appealNumber: "",
        appealDate: "",
        hasError: false
    };

    const headers = getAuthHeaders(APPEALS_SOURCE.CONTENT);
    if (!headers) {
        appealResponse.hasError = true;
        return appealResponse;
    }

    await httpClient.post(appealsUrl, {
        formId: request.formId,
        appealerName: request.appealerName,
        contactEmail: request.contactEmail,
        appealerJustification: request.appealerJustification
    }, {
        headers: headers
    })
        .then(function (res) {
            if (res.status === 200) {
                appealResponse = { ...res.data };
            }

            if (res.status === 500) {
                appealResponse.hasError = true;
            }
        })
        .catch(function (error) {
            if (error.response?.status === 401) {
                throw error;
            }

            appealResponse.hasError = true;
        })

    return appealResponse;
};

export async function postAccountAppeal(request: IAccountAppealSubmissionRequest) {
    let appealResponse: IAccountAppealSubmissionResponse = {
        appealNumber: "",
        appealDate: "",
    };

    const headers = getAuthHeaders(APPEALS_SOURCE.ACCOUNT);
    if (!headers) {
        appealResponse.hasError = true;
        return appealResponse;
    }

    await httpClient.post(appealsUrl + "/account", {
        userId: request.appealerUserId,
        appealerName: request.appealerName,
        contactEmail: request.contactEmail,
        appealerJustification: request.appealerJustification,
        productId: request.product,
        locale: request.locale,
    }, {
        headers: headers
    })
        .then(function (res) {
            if (res.status === 200) {
                appealResponse = { ...res.data };
            }

            if (res.status === 500) {
                appealResponse.hasError = true;
            }
        })
        .catch(function (error) {
            if (error.response?.status === 401) {
                throw error;
            }

            appealResponse.hasError = true;
        })

    return appealResponse;
};

